import { Nothing, Just } from 'monet';

// TODO: Move to its-js. Maybe incorporate in the toMaybe fn already there
const dateToMaybe = date =>
  date.toString() !== 'Invalid Date'
    ? Just(date)
    : Nothing();

export default dateToMaybe;
